import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { QuoteItem } from "../types/ingredient";
interface QuoteContextValue {
  items: QuoteItem[];
  has: (id: string) => boolean;
  toggle: (item: QuoteItem) => void;
  remove: (id: string) => void;
  clear: () => void;
  isOpen: boolean;
  open: () => void;
  close: () => void;
}
const QuoteContext = createContext<QuoteContextValue | null>(null);
export function QuoteProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [items, setItems] = useState<QuoteItem[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const has = useCallback((id: string) => items.some(i => i.id === id), [items]);
  const toggle = useCallback((item: QuoteItem) => {
    setItems(prev => prev.some(i => i.id === item.id) ? prev.filter(i => i.id !== item.id) : [...prev, item]);
  }, []);
  const remove = useCallback((id: string) => setItems(prev => prev.filter(i => i.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);
  const value = useMemo(() => ({
    items,
    has,
    toggle,
    remove,
    clear,
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }), [items, has, toggle, remove, clear, isOpen]);
  return <QuoteContext.Provider value={value} data-id="element-324" data-mp="3o2ozxycno5ue">{children}</QuoteContext.Provider>;
}
export function useQuote() {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
}